import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseHttpClient } from './http-client';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class TenantGroupAccessService {
  private apiUrl: string;

  constructor(
    private http: BaseHttpClient,
    private configService: ConfigService
  ) {
    this.apiUrl = `${this.configService.get('apiBaseUrl')}/TenantGroupAccess`;
  }

  /**
   * Get all tenant groups that the current user (employee) has access to
   */
  getUserAvailableTenants(): Observable<any> {
    return this.http.get(`${this.apiUrl}/user-tenants`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Get all employees and their tenant group access for current tenant
   * (Admin feature - shows all employees in current tenant)
   */
  getEmployeeAccess(): Observable<any> {
    return this.http.get(`${this.apiUrl}/employee-access`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Grant access to a tenant group for a user
   * @param userEmail User email (from UserManagement.userEmail or userName)
   * @param groupID Tenant group ID to grant access to
   */
  grantAccess(userEmail: string, groupID: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/grant-access`, {
      userEmail,
      groupID
    }).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Revoke access to a tenant group for an employee
   * @param accessID The TenantGroupAccessID to revoke
   */
  revokeAccess(accessID: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/revoke-access/${accessID}`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Get available tenant groups for granting access
   */
  getAvailableGroups(): Observable<any> {
    return this.http.get(`${this.apiUrl}/available-groups`).pipe(
      map((response: any) => response)
    );
  }

  /**
   * Get users in current tenant with pagination (reuses User Management endpoint pattern)
   * @param orderBy Column to sort by (default: userFullname)
   * @param orderByDir Sort direction (default: asc)
   * @param skip Number of records to skip (pagination)
   * @param pageSize Number of records per page
   */
  getTenantUsers(orderBy: string = 'userFullname', orderByDir: string = 'asc', skip: number = 0, pageSize: number = 9999): Observable<any> {
    return this.http.get(`${this.apiUrl}/tenant-users?orderBy=${orderBy}&orderByDir=${orderByDir}&skip=${skip}&pageSize=${pageSize}`).pipe(
      map((response: any) => response)
    );
  }
}
